import { StyledTag } from '@app/components/tag/Tag';
import type { Client } from '@app/services/api.types';
import { fn } from '@app/utils';
import { Descriptions, Divider, Drawer, type DescriptionsProps, type DrawerProps } from 'antd';

export type ClientDrawerProps = DrawerProps & {
    data: Client | null;
};

export const ClientDrawer = ({ data, ...props }: ClientDrawerProps) => {
    const detailsItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'First Name',
            children: data?.first_name || '-',
        },
        {
            key: '2',
            label: 'Last Name',
            children: data?.last_name || '-',
        },
        {
            key: '3',
            label: 'Email',
            children: data?.email || '-',
        },
        {
            key: '4',
            label: 'Phone Number',
            children: data?.telephone || '-',
        },
        {
            key: '5',
            label: 'Role',
            children: data?.role_name || '-',
        },
    ];

    const interactionsItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Last Login',
            children: data?.last_login
                ? fn.formatDate(data?.last_login, 'DD/MM/YYYY, HH:mm:ss')
                : '-',
        },
        {
            key: '2',
            label: 'TOTP Enabled?',
            children: (
                <StyledTag
                    color={data?.totp_enabled ? 'green' : 'default'}
                    style={{ minWidth: 38 }}>
                    {data?.totp_enabled ? 'Yes' : 'No'}
                </StyledTag>
            ),
        },
    ];

    const renderDetailsTab = () => {
        return (
            <>
                <Descriptions
                    title="Details"
                    colon={false}
                    layout="vertical"
                    items={detailsItems}
                    column={2}
                />
                <Divider />
                <Descriptions
                    title="Interactions"
                    colon={false}
                    layout="vertical"
                    items={interactionsItems}
                    column={2}
                />
            </>
        );
    };

    return (
        <Drawer
            title={
                <>
                    <span>Client Details</span>
                    {data?.id ? (
                        <div className="ant-drawer-header-meta">
                            <span>ID: {data?.id}</span>
                        </div>
                    ) : null}
                </>
            }
            size={700}
            closable={{ 'aria-label': 'Close Button' }}
            {...props}>
            {renderDetailsTab()}
        </Drawer>
    );
};

export default ClientDrawer;
